// eslint-disable-next-line max-len
export const YOUTUBE_COMMON_VIDEO_ID_REGEXP = /^(?:(?:https?:)?(?:\/\/)?(?:w{3}\.)?)?youtu(?:be\.com\/watch\?(?:.+)?v=|\.be\/)([A-Za-z0-9_-]{11})(?:.+)?$/gi;

// eslint-disable-next-line max-len
export const YOUTUBE_SHORTS_VIDEO_ID_REGEXP = /^(?:(?:https?:)?(?:\/\/)?(?:w{3}\.)?)?youtube\.com\/shorts\/([A-Za-z0-9_-]{11})(?:.+)?$/gi;

// eslint-disable-next-line max-len
export const YOUTUBE_EMBED_VIDEO_ID_REGEXP = /^(?:(?:https?:)?(?:\/\/)?(?:w{3}\.)?)?youtube\.com\/embed\/([A-Za-z0-9_-]{11})(?:.+)?$/gi;

const parseMaybeYouTube = (value) => {
    if (typeof value !== 'string') {
        return false;
    }

    const valueString = value.toString();

    const [match = []] = valueString.matchAll(YOUTUBE_COMMON_VIDEO_ID_REGEXP);
    const [embedMatch = []] = valueString.matchAll(YOUTUBE_EMBED_VIDEO_ID_REGEXP);
    const videoId = match[1] || embedMatch[1];

    if (videoId) {
        return {
            type: 'youtube',
            src: `https://www.youtube.com/embed/${videoId}`,
            options: {
                type: 'default',
            },
        };
    }

    const [shortMatch = []] = valueString.matchAll(YOUTUBE_SHORTS_VIDEO_ID_REGEXP);
    const shortId = shortMatch[1];

    if (shortId) {
        return {
            type: 'youtube',
            src: `https://www.youtube.com/embed/${shortId}`,
            options: {
                type: 'shorts',
            },
        };
    }
};

export default parseMaybeYouTube;
